import React from "react";

const FootSpaWellness = () => {
  return (
    <div className="headSpaHeadContainer">
      <h2>A Holistic Approach to Wellness</h2>

      <p>
        In addition to offering the{" "}
        <a href="https://scentlifestyle.com/foot-massage-in-bangalore">
          best foot massage in Bangalore
        </a>
        , SCENT also provides a range of other wellness services. These include
        body massages, facials, and spa treatments, all designed to promote
        overall well-being. The salon's holistic approach to wellness ensures
        that clients can enjoy a comprehensive experience that addresses both
        physical and mental health.
      </p>
    </div>
  );
};

export default FootSpaWellness;
